/**
 * Temporary local stand-in for `@servicetitan/web-chat-types` 1.3.0
 * (`WEBCHAT_MESSAGE_TYPE.EXPAND_AVAILABILITY`). Published types 1.2.0 does not include this
 * parent message. Swap to the shared package after the Sept 2026 freeze (SETO-7778). This is the
 * one exception to the "no local wire unions" rule in AGENTS.md, and it says so there.
 *
 * Wire: `{ type: 'webchat:expand-availability', available: boolean }`
 */
export const WEBCHAT_EXPAND_AVAILABILITY = 'webchat:expand-availability' as const;

export type ExpandAvailabilityMessage = {
  type: typeof WEBCHAT_EXPAND_AVAILABILITY;
  available: boolean;
};

export function isExpandAvailabilityMessage(data: unknown): data is ExpandAvailabilityMessage {
  if (typeof data !== 'object' || data === null || !('type' in data)) return false;
  const message = data as { type: unknown; available?: unknown };
  return message.type === WEBCHAT_EXPAND_AVAILABILITY && typeof message.available === 'boolean';
}
